import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsServicedeskCustomerNotificationsRoute } from '@jira/router-routes__project-settings-service-desk-customer-notifications-routes/src/projectSettingsServicedeskCustomerNotificationsRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ServiceDeskCustomerNotifications, {
	LazyProjectSettingsServiceDeskCustomerNotifications,
} from './ui/service-desk-customer-notifications/index.tsx';

export const projectSettingsServicedeskCustomerNotificationsRouteEntry: Route = createEntry(
	projectSettingsServicedeskCustomerNotificationsRoute,
	() => ({
		group: 'project-settings-servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskCustomerNotifications,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskCustomerNotifications],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
